import { GridColDef } from "@mui/x-data-grid";
import StatusToggler from "../../components/buttons/StatusToggler";
import EditLinkAction from "../../components/cards/card-actions/EditLinkAction";
import { Link } from "react-router-dom";

export const offerColumns: GridColDef[] = [
  {
    field: "body",
    headerName: "محتوي العرض",
    width: 400,
    sortable: false,
    filterable: false,
    hideSortIcons: true,
    disableColumnMenu: true,
    valueGetter(value, row) {
      return value ?? "_";
    },
  },
  {
    field: "business_name",
    headerName: "اسم النشاط",
    width: 160,
    sortable: false,
    filterable: false,
    hideSortIcons: true,
    disableColumnMenu: true,
    renderCell(params) {
      return (
        <Link to={`/businesses/${params?.row?.business?.id}`}>
          {params?.row?.business?.title}
        </Link>
      );
    },
  },
  {
    field: "expires_at",
    headerName: "تاريخ انتهاء العرض",
    width: 160,
    sortable: false,
    filterable: false,
    hideSortIcons: true,
    disableColumnMenu: true,
  },
  {
    field: "apperance_expires_at",
    headerName: "تاريخ انتهاء ظهور العرض",
    width: 160,
    sortable: false,
    filterable: false,
    hideSortIcons: true,
    disableColumnMenu: true,
  },
  {
    field: "status",
    headerName: "الحالة",
    width: 60,
    sortable: false,
    filterable: false,
    hideSortIcons: true,
    disableColumnMenu: true,
    renderCell: (params: any) => {
      return (
        <StatusToggler
          defaultValue={params?.row?.is_disabled || false}
          apiPath={`/business-offers/${params?.row?.id}`}
        />
      );
    },
  },
  {
    field: "edit",
    headerName: "تعديل",
    width: 60,
    sortable: false,
    filterable: false,
    hideSortIcons: true,
    disableColumnMenu: true,
    renderCell(params) {
      return (
        <EditLinkAction
          to={`/businesses/${params?.row?.business?.id}/offers/${params?.row?.id}`}
        />
      );
    },
  },
];
